'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var AbortError = require('../error/AbortError.js');
function delay(ms) {
    var signal = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).signal;
    return new Promise(function(resolve, reject) {
        var abortError = function() {
            reject(new AbortError.AbortError());
        };
        var abortHandler = function() {
            clearTimeout(timeoutId);
            abortError();
        };
        if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
            return abortError();
        }
        var timeoutId = setTimeout(function() {
            signal === null || signal === void 0 ? void 0 : signal.removeEventListener('abort', abortHandler);
            resolve();
        }, ms);
        signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', abortHandler, {
            once: true
        });
    });
}
exports.delay = delay;
